<template>
    <div>
        <template>
            <h2>店舗情報</h2>
            <v-container>
                <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td>店舗名</td>
                                <td>{{ store_info.store_name }}</td>
                            </tr>
                            <tr>
                                <td>住所</td>
                                <td v-if="!confirmed_adress">
                                    <v-text-field v-model="address" label="住所を入力" clearable></v-text-field>
                                    <v-btn color="primary" @click="confirmedAddress">確定</v-btn>
                                </td>
                                <td v-if="confirmed_adress">
                                    {{ address }}
                                </td>
                            </tr>
                            <tr>
                                <td>担当者</td>
                                <td v-if="!confirmed_manager">
                                    <v-text-field v-model="manager" label="担当者名を入力" clearable></v-text-field>
                                    <v-btn color="primary" @click="confirmedManager">確定</v-btn>
                                </td>
                                <td v-if="confirmed_manager">
                                    {{ manager }}
                                </td>
                            </tr>
                            <tr>
                                <td>メールアドレス</td>
                                <td>{{ store_info.email }}</td>
                            </tr>
                            <tr>
                                <td>アカウント作成日</td>
                                <td>{{ store_info.date_joined }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-container>
        </template>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            store_info: {},
            address: '',
            confirmed_adress: null,
            manager: '',
            confirmed_manager: null,
        }
    },
    methods: {
        confirmedAddress() {
            this.confirmed_adress = this.address
        },
        confirmedManager() {
            this.confirmed_manager = this.manager
        }
    },
    mounted: function () {
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/account/info`, {
            params: {
                store_info: true,
                store_id: this.$store.getters.getStoreId
            }
        })
        .then(res => {
            this.store_info = res.data
        })
    }
}
</script>
